import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";

import Logo from '../assets/logo.png'
import Crown from '../assets/Path 664.png'
import Radio from '../assets/Group 365.png'
import Mockup from '../assets/Group 378.png'

// import PlayStore from '../assets/playstore.png'
// import Huwaei from '../assets/huwaei.svg'
// import Apple from '../assets/appleicon.png'
import Apple from '../assets/apple-logo-svgrepo-com (1).svg'
import PlayStore from '../assets/playstore-svgrepo-com.svg'
import { ReactComponent as HuwaeiIcon } from '../assets/huwaei.svg';

import FooterBG from '../assets/Group-350.png'

import { ReactComponent as CookingTvArabic } from '../assets/Cooking-Tv-Arabic.svg';
import { ReactComponent as CookingTvFrench } from '../assets/Cooking-TV-French.svg';
import { ReactComponent as CulturalFlavors } from '../assets/Cultural-Flavors.svg';
import { ReactComponent as EnglishClubTv } from '../assets/English-Club-TV.svg';
import { ReactComponent as FitnessTv } from '../assets/Fitness-TV.svg';
import { ReactComponent as GossipIcon } from '../assets/Gossip.svg';
import { ReactComponent as JokeTvIcon } from '../assets/Joke-TV.svg';
import { ReactComponent as MoviesNewsIcon } from '../assets/Movies-News.svg';
import { ReactComponent as PrettyTvIcon } from '../assets/Pretty-TV.svg';

import { Download, CreditCard } from 'lucide-react';




export default function LandingPage() {

    const navigate = useNavigate();


    const [iconHeight, setIconHeight] = useState('60px');
    const [IconSecondSizes, setIconSecondSizes] = useState(20);

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [country, setCountry] = useState('');

    const [loading, setLoading] = useState(false);
    const [Resetloading, setResetloading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);


    const [message, setMessage] = useState("");
    const [ResetMessage, setResetMessage] = useState("");

    const [resetPassword, setResetPassword] = useState("");

    const [iframeSrc, setIframeSrc] = useState('');

    const features = [
        { title: 'COOKING TV ARABIC', icon: CookingTvArabic },
        { title: 'COOKING TV FRENCH', icon: CookingTvFrench },
        { title: 'CULTURAL FLAVORS', icon: CulturalFlavors },
        { title: 'ENGLISH CLUB TV', icon: EnglishClubTv },
        { title: 'FITNESS TV', icon: FitnessTv },
        { title: 'GOSSIP', icon: GossipIcon },
        { title: 'JOKE TV', icon: JokeTvIcon },
        { title: 'MOVIES NEWS', icon: MoviesNewsIcon },
        { title: 'PRETTY TV', icon: PrettyTvIcon },
    ];

    useEffect(() => {
        function handleResize() {
            if (window.innerWidth <= 768) { // You can adjust 768px for mobile
                setIconHeight('30px');
                setIconSecondSizes(20)
            } else {
                setIconHeight('60px');
                setIconSecondSizes(20)
            }
        }

        handleResize(); // call it once to set the initial size

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);





    useEffect(() => {
        const user = JSON.parse(localStorage.getItem('Laki_user_data'));
        if (user) {
            navigate('/home', { replace: true }); // Redirect logged-in users to /home
        }else{
            console.log("No user found ")
        }
    }, []);

    function Login() {
        setLoading(true)
        fetch(`https://apiv2.mobileartsme.com/login?phonenumber=${username}&password=${password}&type=signin&serviceid=864&country=${country}`)
            .then(response => response.json())
            .then(resp => {
                if (resp.Error === 1) {
                    setMessage(resp.Result);
                    setLoading(false)
                }

                if (resp.Error === 0 && resp.Result.Status != 0) {
                    setLoading(false)
                    setMessage(resp.Result.Description);
                }

                if (resp.Error === 0 && resp.Result.Status === 0) {
                    setLoading(false)
                    console.log(resp.Result)
                    resp.Result.Phone = username
                    localStorage.setItem("Laki_user_data", JSON.stringify(resp.Result))
                    navigate("/home");
                }
                console.log(resp)

            })
    }

    function resetPasswordFunction() {
        setResetloading(true)
        fetch(`https://apiv2.mobileartsme.com/laki_forgetpass?phonenumber=${resetPassword}&apisource=1&language=LB`)
            .then(response => response.json())
            .then(resp => {
                if (resp.error === 1) {
                    setResetMessage(resp.result);
                    setResetloading(false)
                }

                if (resp.error === 0 && resp.result != 0) {
                    setResetloading(false)
                    setResetMessage(resp.Result.Description);
                }

                if (resp.error === 0 && resp.result === 0) {
                    setResetloading(false)
                    console.log(resp.Result)
                    setResetMessage("A new password has been sent to your phone number.")
                }
                console.log(resp)

            })
    }

    const openOffcanvas = (url) => {
        setIsLoading(true); // Show loader
        setIframeSrc(url);
        const offcanvas = document.getElementById('profileOffcanvas');
        if (offcanvas) {
            offcanvas.classList.add('show');
            offcanvas.style.visibility = 'visible';
            offcanvas.style.transform = 'translateX(0)';
            document.body.classList.add('offcanvas-open');
        }
    };


    const closeOffcanvas = () => {
        const offcanvas = document.getElementById('profileOffcanvas');
        if (offcanvas) {
            offcanvas.classList.remove('show');
            offcanvas.style.visibility = 'hidden';
            offcanvas.style.transform = 'translateX(100%)';
            document.body.classList.remove('offcanvas-open');
        }
        setIframeSrc('');       // Clear iframe
        setIsLoading(false);    // Reset loader
    };


    return (
        <div>
            <div className='header_1 ' >
                <div className='container d-flex flex-row justify-content-between align-items-center'>
                    <img width={90} src={Logo} />
                    <button className='btn btn-primary' onClick={() => window.location.href = '#login'} >Login</button>
                </div>
            </div>

            <section className='hero' >

                <div data-aos='zoom-in' className='d-flex flex-column justify-content-center align-items-center' >
                    <h1 className='text-light' >I Am Healthy, Lucky, Pretty.</h1>
                    <h2 className='pink' >I Am Laki</h2>
                    <p className='text-light' >Womans App With Wide Video Collection</p>
                    <div className='d-flex flex-row gap-2' >
                        <button type="button" class="btn btn-primary"
                            onClick={() => window.location.href = '#login'} >Download Our App <Download size={IconSecondSizes} /></button>

                        <a type="button" class="btn btn-primary" href='https://ma-appsfiles.s3.eu-central-1.amazonaws.com/AE_PaymentPage/index.html?portal=Laki' target='_blank'>
                            Subscribe <CreditCard size={IconSecondSizes} /></a>

                    </div>
                </div>
            </section>

            <section className='features container my-5 pb-5' >
                <div className='d-flex flex-column align-items-center' >

                    <div className='d-flex flex-column align-items-center' data-aos="zoom-in">

                        <h2 className='text-light' >Limited Features</h2>
                        <p className='text-light' >A Limited Number of Features of 7 Categories</p>
                        <hr></hr>
                    </div>

                    <div className="features-grid mt-4">
                        {features.map((feature, index) => (
                            <div key={index} className="feature-card" data-aos="zoom-in">
                                <feature.icon
                                    fill="var(--main-pink)"
                                    style={{
                                        color: 'var(--main-pink)',
                                        width: '50px',
                                        height: iconHeight, // <-- 👈 controlled by screen size
                                    }}
                                />
                                <h3 className="feature-title text-center">{feature.title}</h3>
                            </div>
                        ))}
                    </div>
                </div>

            </section>


            <section className='premiunm-features container my-5 pt-5' >
                <h2 className='text-light text-center' >Premium Features</h2>
                <hr></hr>

                <div className='row mt-5' >
                    <div className='col-lg-6' >

                        <div className='d-flex flex-column justify-content-center h-100 gap-4' >
                            <div className='d-flex flex-row gap-3' data-aos="zoom-in">
                                <img src={Crown} height={iconHeight} />
                                <div>
                                    <h3 className='pink' >EXCLUSIVE VIDEO LIBRARY :</h3>
                                    <p className='text-light' >UNLOCK A UNIQUE SELECTION OF PREMIUM-ONLY VIDEOS AND DOCUMENTARIES.</p>
                                </div>
                            </div>

                            <div className='d-flex flex-row gap-2' data-aos="zoom-in" >
                                <img src={Radio} height={iconHeight} />
                                <div>
                                    <h3 className='pink' >LIVE STREAMING PRIVILEGES:</h3>
                                    <p className='text-light' >GAIN ACCESS TO EXCLUSIVE LIVE STREAMING CHANNELS AND EVENTS.</p>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className='col-lg-6' >
                        <img width={'100%'} src={Mockup} data-aos="zoom-in" />
                    </div>
                </div>
            </section>


            <section id='login' className='my-5 py-5' data-aos="zoom-in" >

                <div className='container'>
                    {/* <img src={Logo} width={100} /> */}
                    <div className='row' >

                        <div className='col-lg-6 mb-3' >
                            <div style={{ maxWidth: '400px' }} >
                                <div>
                                    <h3 className='pink'>Log In</h3>
                                    <p className='text-light'>Please enter your credentials to access your premium features.</p>
                                </div>


                                <input type='text' placeholder='Username' className='form-control mb-2' onChange={(e) => setUsername(e.target.value)} />
                                <div className='d-flex felx-row align-items-center justify-content-center gap-2' >
                                    <input type='password' placeholder='Password' className='form-control' onChange={(e) => setPassword(e.target.value)} />
                                    <button className='btn btn-primary' onClick={() => Login()}>
                                        {loading ?

                                            <span class="spinner-border spinner-border-sm" aria-hidden="true"></span> : "Login"}
                                    </button>
                                </div>
                                <p className='text-light pt-2 mb-0' style={{ cursor: 'pointer' }} data-bs-toggle="modal" data-bs-target="#resetModal" >Forgot Your Password ?</p>
                                <p style={{ color: 'red', fontWeight: '600' }}>{message}</p>
                            </div>
                        </div>


                        <div className='col-lg-3 mb-4' >
                            <h3 className='text-light' >Links</h3>

                            <div className='d-flex flex-column gap-2 pt-2' >
                                <a className='text-light' onClick={() => openOffcanvas('https://d2saof99ugqr6h.cloudfront.net/PrivacyPolicy?id=864&langcode=en')} >Privacy Policy</a>
                                <a href='#features' className='text-light' onClick={() => openOffcanvas('https://d2saof99ugqr6h.cloudfront.net/TermsAndConditions?id=864&langcode=en')}>Terms & Conditions</a>
                                <a href='/contact' className='text-light'>Contact Us</a>
                            </div>

                        </div>


                        <div className='col-lg-3' >
                            <h3 className='text-light' >Download Our App</h3>

                            <div className='d-flex flex-column gap-2 pt-2' >

                                <a href='https://apps.apple.com/app/id1478271139' target='_blank' className='btn-os'>
                                    <img src={Apple} />
                                    <div>
                                        <span>DOWNLOAD ON THE</span>
                                        <p>App Store</p>
                                    </div>
                                </a>

                                <a href='https://play.google.com/store/apps/details?id=com.videos.entertainment' target='_blank' className='btn-os'>
                                    <img src={PlayStore} />
                                    <div>
                                        <span>GET IT ON</span>
                                        <p>Google Play</p>
                                    </div>
                                </a>

                                <a href='https://appgallery.huawei.com/#/app/C106088175' target='_blank' className='btn-os'>
                                    <HuwaeiIcon style={{ color: 'red' }} />


                                    <div>
                                        <span>DOWNLOAD ON THE</span>
                                        <p>App Gallery</p>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

            </section>



            {/* Modal */}
            <div class="modal fade" id="resetModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header" style={{ border: 'none' }}>
                            <h1 class="modal-title fs-5" id="exampleModalLabel">Forgot Your Password ?</h1>
                        </div>
                        <div class="modal-body">
                            <p>Enter your phone number and we will send you a SMS with your new password.</p>
                            <input type='text' placeholder='Username' className='form-control mb-2' onChange={(e) => setResetPassword(e.target.value)} />
                            <p>{ResetMessage}</p>
                        </div>
                        <div class="modal-footer" style={{ border: 'none' }}>
                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                            <button type="button" class="btn btn-primary" onClick={() => resetPasswordFunction()} >
                                {Resetloading ? <span class="spinner-border spinner-border-sm p-2" aria-hidden="true"></span> : "Reset Password"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Right Offcanvas */}
            <div
                id="profileOffcanvas"
                className="offcanvas offcanvas-end"
                style={{
                    width: '80%',
                    position: 'fixed',
                    top: 0,
                    right: 0,
                    height: '100vh',
                    backgroundColor: 'white',
                    zIndex: 1050,
                    transition: 'transform 0.3s ease-in-out',
                    visibility: 'hidden',
                    transform: 'translateX(100%)'
                }}
            >
                <div className="offcanvas-header">
                    <button type="button" className="btn-close" onClick={closeOffcanvas}></button>
                </div>
                <div className="offcanvas-body p-0">
                    <iframe
                        src={iframeSrc}
                        title="Info Frame"
                        width="100%"
                        height="100%"
                        frameBorder="0"
                        onLoad={() => setIsLoading(false)}
                        style={{ border: 'none', display: isLoading ? 'none' : 'block' }}
                    ></iframe>
                </div>
                {isLoading && (
                    <div className="d-flex justify-content-center align-items-center" style={{ height: '100%' }}>
                        <div className="spinner-border  pink" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                )}
            </div>

        </div>
    )
}


